import React from 'react';
import BotIcon from '../../../../../../../assets/icons/BotIcon';

/*
 * A bot's picture, shown and nothing more.
 *
 * The sidebar row used to draw a FileUpload here, so the way to change a bot's
 * picture was to notice that hovering it revealed a bin, and the way to remove
 * one was to press that bin - a control that only exists once the pointer is on
 * top of it. Changing the picture lives on the bot's own page now; this is the
 * same circle without the machinery behind it.
 *
 * A bot with no picture gets the bot mark rather than an empty ring, which is
 * also what the chat screens draw for one.
 */
const BotAvatar = ({client, size = 44, imgSize = 34}) => (
    <span
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: size,
            height: size,
        }}
    >
        {client.image ? (
            <img
                src={client.image}
                width={imgSize}
                height={imgSize}
                alt=""
                style={{borderRadius: '50%', objectFit: 'cover', flexShrink: 0}}
            />
        ) : (
            <BotIcon
                width={imgSize}
                height={imgSize}
                stroke="currentColor"
                style={{color: 'var(--ds-fg-tertiary)'}}
            />
        )}
    </span>
);

export default BotAvatar;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/overview/BotAvatar.jsx